import React from 'react'
// début de modification Kani
import ReactEcharts from "echarts-for-react";
// fin de modification Kani

/*
import {
    XYPlot,
    VerticalGridLines,
    HorizontalBarSeries,
    LabelSeries,
    makeVisFlexible,
  } from "react-vis";
*/

function GrapheIR2({dataIR2_actuel, dataIR2_nouveau}) {
    // début de modification Kani
    const categories = dataIR2_actuel.map((d) => d.y);

    const option = {
        animation: false,
        grid: { left: 20, right: 100, top: 10, bottom: 30, containLabel: true },
        xAxis: {
            type: "value",
            splitLine: { lineStyle: { color: "#C6C6C6" } },
            axisLabel: { color: "#000" },
        },
        yAxis: {
            type: "category",
            data: categories,
            axisLabel: { show: false }, // 👈 masque uniquement les nombres
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { lineStyle: { color: "#C6C6C6" } }, // 👈 lignes grises conservées
        },
        series: [
            {
                name: "Actuel",
                type: "bar",
                barWidth: "45%",
                label: {
                    show: true,
                    position: "right",
                    formatter: (p) => Math.abs(p.value).toLocaleString() + " €",
                    color: "#20BF3B",
                    fontWeight: "bold",
                },
                data: dataIR2_actuel.map((d) => ({
                    value: d.x,
                    itemStyle: { color: d.color || "#20BF3B", borderColor: "#20BF3B", borderWidth: 3 },
                })),
            },
            {
                name: "Nouveau",
                type: "bar",
                barWidth: "45%",
                label: {
                    show: true,
                    position: "right",
                    formatter: (p) => Math.abs(p.value).toLocaleString() + " €",
                    color: "black",
                    fontWeight: "bold",
                },
                data: dataIR2_nouveau.map((d) => ({
                    value: d.x,
                    itemStyle: { color: d.color || "transparent", borderColor: "black", borderWidth: 3 },
                })),
            },
        ],
    };

    return (
        <div>
            <ReactEcharts option={option} style={{ height: "350px", width: "100%" }} />
        </div>
    );
    // fin de modification Kani

    /*
    const labelDataActuel = dataIR2_actuel.map((d) => ({ x: d.x, y: d.y }));
    const labelDataNouveau = dataIR2_nouveau.map((d) => ({ x: d.x+1, y: d.y }));
    const FlexXYPlot=makeVisFlexible(XYPlot)
    return (
        <div>
            <FlexXYPlot  height={350}  colorType="literal" >
                <VerticalGridLines  style={{stroke: '#C6C6C6'}} />
                <HorizontalBarSeries style={{stroke: '#20BF3B', strokeWidth:3}} data={dataIR2_actuel} barWidth={0.95} />
                <HorizontalBarSeries style={{stroke: 'black', strokeWidth:3, strokeDasharray:"8, 4"}} data={dataIR2_nouveau} barWidth={0.95} />
                <LabelSeries data={labelDataActuel} getLabel={d => Math.abs(d.x).toLocaleString() + ' €'} style={{fill:'#20BF3B', fontWeight:'bold'}}/>
                <LabelSeries data={labelDataNouveau} getLabel={d => Math.abs(d.x).toLocaleString() + ' €'} style={{fill:'black', fontWeight:'bold'}}/>
            </FlexXYPlot>
        </div>
    );
    */
}

export default GrapheIR2